<template>
  <div class="container">
    <el-row>
      <el-col :span="2">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="22">
        <table>
          <tr>
            <td>仪器名称</td>
            <td>
              <p>{{ form.yqmc1 }}</p>
            </td>
            <td>仪器编号</td>
            <td>
              <p>{{ form.yqbh1 }}</p>
            </td>
            <td>校准有效期</td>
            <td colspan="3">
              <p>{{ form.jzyxq1 }}</p>
            </td>
          </tr>
          <tr>
            <td>仪器名称</td>
            <td>
              <p>{{ form.yqmc2 }}</p>
            </td>
            <td>仪器编号</td>
            <td>
              <p>{{ form.yqbh2 }}</p>
            </td>
            <td>校准有效期</td>
            <td colspan="3">
              <p>{{ form.jzyxq2 }}</p>
            </td>
          </tr>
          <tr>
            <td>环境温度(℃)</td>
            <td>
              <p>{{ form.hjwd }}</p>
            </td>
            <td>相对湿度(﹪RH)</td>
            <td>
              <p>{{ form.xdsd }}</p>
            </td>
            <td>天气</td>
            <td>
              <p>{{ form.tq }}</p>
            </td>
            <td>测试电压值（V）</td>
            <td>
              <p>{{ form.csdyz }}</p>
            </td>
          </tr>
          <tr>
            <td>序号</td>
            <td>被检测设备位置</td>
            <td>被检测设备名称</td>
            <td>测量组别</td>
            <td>测量组别实测阻值</td>
            <td colspan="3">检测结果</td>
          </tr>
          <template v-for="(item,i) in tableData">
            <tr :key="i">
              <td rowspan="6">{{ item.id }}</td>
              <td rowspan="6">{{ item.bjcsbwz }}</td>
              <td rowspan="6">{{ item.bjcsbmc }}</td>
              <td>A-B</td>
              <td>{{ item.absczz }}</td>
              <td rowspan="6" colspan="3">{{ item.jcjg }}</td>
            </tr>
            <tr :key="i">
              <td>B-C</td>
              <td>{{ item.bcsczz }}</td>
            </tr>
            <tr :key="i">
              <td>C-A</td>
              <td>{{ item.casczz }}</td>
            </tr>
            <tr :key="i">
              <td>A-PE</td>
              <td>{{ item.apesczz }}</td>
            </tr>
            <tr :key="i">
              <td>B-PE</td>
              <td>{{ item.bpesczz }}</td>
            </tr>
            <tr :key="i">
              <td>C-PE</td>
              <td>{{ item.cpesczz }}</td>
            </tr>
          </template>
        </table>

      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'report',
      form: {
        yqmc1: '',
        yqbh1: '',
        jzyxq1: '',
        yqmc2: '',
        yqbh2: '',
        jzyxq2: '',
        hjwd: '',
        xdsd: '',
        tq: '',
        csdyz: ''
      },
      tableData: [],
    }
  },
  methods: {
    async getForm() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
        }
        let res = await this.$Api.get("record_cma_jydz1", {params: params});
        if (res) {
          this.form = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("record_cma_jydz", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getForm()
    this.getList()
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>
